module.exports = __webpack_public_path__ + "static/img/bg1.276e9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.jpg
// module id = mg/2
// module chunks = 1